import React from 'react'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TitleText from '../TitleText';
import { Image } from 'components/atoms';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useSelector } from 'react-redux';
import Autoplay from '../Autoplay';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        zIndex: 'auto',
    },
    titleText: {
        display: "none",
        [theme.breakpoints.up('md')]: {
            display: "block",
        },
    },
    swiperSlide: {
        width: 'auto',
        paddingTop: "20px",
        background: "linear-gradient(150deg, rgb(10, 10, 10, 0.60) 30%, rgb(30, 30, 30, 0.20) 50%, rgb(10, 10, 10, 0.60) 70%)",
        height: "400px",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: "column",
        [theme.breakpoints.up('md')]: {
            height: "400px",
        },
    },
    swiperImageSlide: {
        width: "80%",
        height: "300px",
        [theme.breakpoints.up('md')]: {
            height: "300px",
        },
    },
    image: {
        objectFit: 'cover',
    },
    typography: {
        textAlign: "center",
        fontFamily: "Basic",
        fontSize: "24px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "80px",
        textTransform: "uppercase",
        color: "#fff",
        [theme.breakpoints.up('md')]: {
            fontSize: "30px",
        },
    },
}));

const images = [{
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place3.jpg',
    alt: '',
}, {
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place1.jpg',
    alt: '',
}, {
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place2.jpg',
    alt: '',
}, {
    src: 'https://www.navahang.com/images/2023/09/600x338/Evan-Band-Faramooshkar-Live-video.jpg',
    alt: '',
}, {
    src: 'https://www.navahang.com/images/2023/09/600x338/Masoud-Sadeghloo-Akhare-Shab-Live-video.jpg',
    alt: '',
}, {
    src: 'https://www.navahang.com/images/2023/08/600x338/Azel-Soroode-Fareh-Iran-video.jpg',
    alt: '',
}, {
    src: 'https://www.navahang.com/images/2023/08/600x338/Amir-Zehi-O-Sole-Mio-video.jpg',
    alt: '',
}, {
    src: '	https://www.navahang.com/images/2023/08/600x338/Roozbeh-Bemani-Bad-Az-Raftan-video.jpg',
    alt: '',
}, {
    src: 'https://www.navahang.com/images/2023/08/600x338/Saaro-Atel-o-Batel-video.jpg',
    alt: '',
}, {
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place1.jpg',
    alt: '',
},

]

const StreamLeaders = () => {
    const classes = useStyles();

    const StreamLeadersData = useSelector((state) => state.cover.discovers?.top_artists?.data);

    return (
        <div className={classes.root}>
            <div className={classes.titleText}>
                <TitleText text={"stream leaders (top 10)"} />
            </div>

            <Swiper
                slidesPerView={3}
                spaceBetween={0}
                loop={true}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    320: {
                        slidesPerView: 1,
                    },
                    990: {
                        slidesPerView: 3,
                    },
                }}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }}
                modules={[Autoplay]}
            >
               {StreamLeadersData && StreamLeadersData.map((item, index) => (
                        <SwiperSlide
                            className={clsx(
                                'swiper-image__slide',
                                'swiper-slide',
                                classes.swiperSlide,
                            )}
                            key={index}
                        >
                            <div className={classes.swiperImageSlide}>
                                <Image
                                    src={item.avatarURL}
                                    alt={item.avatarURL}
                                    srcSet={item.avatarURL}
                                    lazyProps={{ width: '100%', height: '100%' }}
                                    className={clsx(
                                        'swiper-image__item',
                                        classes.image,
                                    )}
                                />
                            </div>
                            <Typography className={classes.typography}>
                                {item.name}
                            </Typography>
                        </SwiperSlide>
                    ))}
            </Swiper>
        </div >
    )
}


StreamLeaders.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};


export default StreamLeaders
